var map = {
	"./p1.jpg": 61,
	"./p10.jpg": 62,
	"./p2.jpg": 63,
	"./p3.png": 64,
	"./p4.png": 65,
	"./p5.jpg": 66,
	"./p6.jpg": 67,
	"./p7.jpg": 68,
	"./p8.jpg": 69,
	"./p9.jpg": 70
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects ^\.\/.*$
// module id = 219
// module chunks = 1